export default __webpack_public_path__ + "static/media/InvalidCertificate.e250aa03.jpeg";